exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Home-module__container___AMjYz{position:absolute;overflow:hidden;height:var(--app-height);width:100vw;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.Home-module__container___AMjYz .Home-module__avatar___3QaNy{max-width:-moz-max-content;max-width:max-content;grid-area:33/22/span 2/span 2;z-index:15}.Home-module__container___AMjYz .Home-module__confetti___xZiYY{transform:translate(50%,calc(var(--app-height)*0.5));position:relative;z-index:20}.Home-module__container___AMjYz .Home-module__left-menu___3DM95{position:fixed;top:2em;left:2em;display:grid;gap:2em;z-index:10}", ""]);

// exports
exports.locals = {
	"container": "Home-module__container___AMjYz",
	"avatar": "Home-module__avatar___3QaNy",
	"confetti": "Home-module__confetti___xZiYY",
	"left-menu": "Home-module__left-menu___3DM95"
};